var map = {
	"./achievement-abstract.svg": "kf84",
	"./blob-modal-header.svg": "A/Fd",
	"./blob.svg": "VYEO",
	"./checkmark-circle.svg": "nm/S",
	"./content-empty-icon.svg": "T79j",
	"./default-avatar.png": "6NQP",
	"./header-bg.svg": "nBia",
	"./high-success.svg": "Ki09",
	"./hubspot-academy-logo-color.svg": "vBX4",
	"./left-arrow-circle.svg": "Gk9P",
	"./logo-upwork.png": "Vs5E",
	"./logo-upwork@2x.png": "ulpN",
	"./logo-upwork@3x.png": "n2/l",
	"./play-icon.svg": "JOpR",
	"./playlist-table.svg": "urKG",
	"./pngs/Jean_full.png": "aAko",
	"./pngs/Jean_mobile.png": "UQm9",
	"./pngs/Jean_thumbnail.png": "893y",
	"./pngs/academy-illustration.png": "wQ55",
	"./pngs/chapter_thumbnail.png": "oO9V",
	"./pngs/practical_exercise_thumbnail.png": "/dGN",
	"./pngs/quiz_thumbnail.png": "mFTs",
	"./pngs/sequence-screen.png": "Lesa",
	"./product-team.jpg": "08Uq",
	"./social-block-link.svg": "f+hz",
	"./storefront-header-blobs.svg": "KUJK",
	"./white-circle-3.svg": "cQKr"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "afnU";